import React, { useEffect, useState } from 'react';
import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import MediaUploadField from '../../../puck/fields/MediaUploadField';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import { detectEmbedProvider } from '../../../media/embedProviders';
import { getMediaSrc } from '../../../media/mediaSource';
import VideoCoverField from './VideoCoverField';

export default function VideoSourceField({ value }) {
  const { itemProps, updateItemProps } = useSelectedItemProps();
  const [pending, setPending] = useState(null);
  const src = getMediaSrc(value);
  useEffect(() => setPending(null), [itemProps.id, src]);
  const apply = (selection) => {
    updateItemProps({
      src: selection.url,
      videoMediaId: selection.mediaId ?? null,
      automaticPoster: selection.poster ?? (selection.url === src ? itemProps.automaticPoster || '' : ''),
      ...(selection.url !== src ? { coverPoster: '', chapters: [] } : {}),
    });
    setPending(null);
  };
  const change = (selection) => {
    if (selection.url !== src && (itemProps.coverPoster || itemProps.chapters?.length)) setPending(selection);
    else apply(selection);
  };
  return (
    <Stack gap="xs">
      <MediaUploadField
        kind="video"
        value={src}
        fieldLabel="Vidéo"
        onChange={(url) => change({ url })}
        onMediaChange={change}
        meta={{ mediaId: itemProps.videoMediaId }}
      />
      {src && !detectEmbedProvider(src) && (
        <VideoCoverField key={`${itemProps.id}:${src}`} src={src} poster={itemProps.coverPoster} automaticPoster={itemProps.automaticPoster} onChange={(coverPoster) => updateItemProps({ coverPoster })} />
      )}
      <Modal opened={!!pending} onClose={() => setPending(null)} title="Remplacer la vidéo ?">
        <Text>La couverture choisie et les chapitres seront retirés avec l’ancienne vidéo.</Text>
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={() => setPending(null)}>Annuler</Button>
          <Button onClick={() => apply(pending)}>Remplacer la vidéo</Button>
        </Group>
      </Modal>
    </Stack>
  );
}
